module.exports = __webpack_public_path__ + "static/media/charliehide.3aaccf30.gif";